import React, { useEffect, useState } from 'react';
import Header from '../common/layout/header';
import Footer from '../common/layout/footer';
import Sidebar from '../common/sidebar';
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import Select from 'react-select';
import { useParams } from 'react-router-dom';
import Loader from "../common/loader";
import { canAction } from '../common/permissionhelper';
const MODULE = 'manage_chefs';
const EditChefs = () => {
  const { id } = useParams();  // Get chefId from URL params
  // Permission checks
  const canEdit = canAction(MODULE, 'edit');
  const isReadOnly = !canEdit; // if true, disable inputs and hide submit
  const [groupName, setGroupName] = useState('');
  const [priceBand, setPriceBand] = useState([]);
  const [priceBands, setPriceBands] = useState([]);  // List of available price bands
  const [accounts, setAccounts] = useState([]);  // List of available accounts (fetched only once)
  const [filteredAccounts, setFilteredAccounts] = useState([]);  // Accounts filtered by selected price band
  const [selectedAccount, setSelectedAccount] = useState([]);  // Multiple accounts selected
  const [primaryAccount, setPrimaryAccount] = useState(null);  // Primary account
  const [status, setStatus] = useState('inactive');  // default or from fetched data
  const [errorMsg, setErrorMsg] = useState({});
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [allChefs, setAllChefs] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(true);
  const [restrictedAccounts, setRestrictedAccounts] = useState([]);
  const [restrictedLoaded, setRestrictedLoaded] = useState(false);
  const [inaccessibleAccounts, setInaccessibleAccounts] = useState([]); // list of strings to show in note
  const [missingPrimaryAccount, setMissingPrimaryAccount] = useState(null);
  const [hoAccountlist, setHoAccountcodelist] = useState([]);
  const [hoAccountLoaded, setHoAccountLoaded] = useState(false);
  const [chefAccountList, setChefAccountList] = useState([]);
  const [chefAccountLoaded, setChefAccountLoaded] = useState(false);
  // Redirect unauthenticated or unauthorized users
  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = '/';
  }
  if (JSON.parse(sessionStorage.getItem('authData')) !== '' &&
    !JSON.parse(sessionStorage.getItem('authData')).adminRole.permissions.includes('manage_chefs')) {
    window.location.href = '/unauthorized';
  }
  // Fetch restricted accounts first
  useEffect(() => {
    http.get(`${BaseUrl}admin/accountcodelist`)
      .then((res) => {
        const ids = res.data?.data?.map(acc => acc.accountCode);
        setRestrictedAccounts(ids || []);
        console.log("Restricted Accounts:", ids);
      })
      .catch((err) => {
        console.error("Failed to fetch restricted accounts", err);
        setRestrictedAccounts([]);
      })
      .finally(() => {
        setRestrictedLoaded(true);
      });
  }, []);
  // fetch hoaccountcode list
  useEffect(() => {
    http.get(`${BaseUrl}admin/hoaccountlist`)
      .then((res) => {
        const Hoids = res.data?.data?.map(acc => acc.accountCode);
        setHoAccountcodelist(Hoids || []);
        console.log("Ho Accounts:", Hoids);
      })
      .catch((err) => {
        console.error("Failed to fetch Ho accounts", err);
        setHoAccountcodelist([]);
      })
      .finally(() => {
        setHoAccountLoaded(true);
      });
  }, []);
  useEffect(() => {
    http.get(`${BaseUrl}admin/chefaccountcodelist`)
      .then((res) => {
        const chefIds = res.data?.data?.map(acc => acc.accountCode);
        setChefAccountList(chefIds || []);
        console.log("Chef Restricted Accounts:", chefIds);
      })
      .catch((err) => {
        console.error("Failed to fetch Chef restricted accounts", err);
        setChefAccountList([]);
      })
      .finally(() => {
        setChefAccountLoaded(true);
      });
  }, []);
  useEffect(() => {
    if (!restrictedLoaded || !hoAccountLoaded || !chefAccountLoaded) return;
    const fetchData = async () => {
      try {
        // Fetch all accounts
        const accountResponse = await http.get(`${BaseUrl}admin/account`);
        const accountsData = accountResponse.data.data;
        let activeAccounts = accountsData.filter(acc => {
          return (
            acc.accountStatus === "active" &&
            acc.accountWebSiteAccess === "Yes"
          );
        });
        // Exclude restricted accounts
        // if (restrictedAccounts.length > 0) {
        //   activeAccounts = activeAccounts.filter(
        //     acc => !restrictedAccounts.includes(acc.accountCode)
        //   );
        // }
        setAccounts(activeAccounts);
        // Get unique price bands
        const uniqueBands = [...new Set(activeAccounts.map(acc => acc.accountPriceListId).filter(Boolean))];
        setPriceBands(uniqueBands);
        // Fetch all chefs for duplicate logic
        const chefsResponse = await http.get(`${BaseUrl}admin/getchefs`);
        const chefs = chefsResponse.data.data;
        setAllChefs(chefs);
        // Fetch this chef
        const chefResponse = await http.get(`${BaseUrl}admin/getchefs/${id}`);
        const chefData = chefResponse.data.data;
        setGroupName(chefData.groupName);
        setStatus(chefData.groupStatus);
        const initialBands = Array.isArray(chefData.priceBand)
          ? chefData.priceBand
          : chefData.priceBand
          ? [chefData.priceBand]
          : [];
        const bandOptions = initialBands.map(pb => ({ value: pb, label: pb }));
        setPriceBand(bandOptions);
        // Filter accounts by selected price band
        const selectedBandValues = bandOptions.map(pb => pb.value);
        const filtered = activeAccounts.filter(acc =>
          selectedBandValues.includes(acc.accountPriceListId) && acc.accountWebSiteAccess === "Yes"
        );
        setFilteredAccounts(filtered);
        // Primary account
        const primary = activeAccounts.find(acc => acc._id === (chefData.primaryAccount?._id || chefData.primaryAccount));
        setPrimaryAccount(primary || null);
        // Sub-accounts
        const chefAccountIds = (chefData.accounts || []).map(a => (a?._id || a));
        const selected = activeAccounts
          .filter(acc => chefAccountIds.includes(acc._id))
          .map(acc => ({ value: acc._id, label: `${acc.accountCode} - ${acc.accountName}` }));
        setSelectedAccount(selected);
        // inaccessible accounts (present in chef group but not in the activeAccounts list)
        const inaccessible = [];
        // check sub-accounts from chefData.accounts
        (chefData.accounts || []).forEach(a => {
          const accId = a?._id || a;
          const stillExists = activeAccounts.some(acc => acc._id === accId);
          if (!stillExists) {
            // only push accountCode (fallback to id if code not available)
            const codeOnly = a?.accountCode || accId;
            inaccessible.push(codeOnly);
          }
        });
        // check primary if it's missing from activeAccounts and not already included
        const primaryIdFromChef = chefData.primaryAccount?._id || chefData.primaryAccount;
        const primaryStillExists = activeAccounts.some(acc => acc._id === primaryIdFromChef);
        if (primaryIdFromChef && !primaryStillExists) {
          const codeOnly = chefData.primaryAccount?.accountCode || primaryIdFromChef;
          setMissingPrimaryAccount(codeOnly);
          if (!inaccessible.includes(codeOnly)) inaccessible.push(codeOnly);
        }
        setInaccessibleAccounts(inaccessible);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };
    if (id) fetchData();
  }, [id, restrictedLoaded, hoAccountLoaded, chefAccountLoaded]);

  const cancelbtn = (e) => {
    e.preventDefault();
    window.location.href = '/development-chef';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canEdit) return;
    setFormSubmitted(true);
    let errors = {};
     //Check for duplicate group name ignore current
    const isDuplicate = allChefs.some(
      chef => chef.groupName.trim().toLowerCase() === groupName.trim().toLowerCase() && chef._id !== id
    );
    if (isDuplicate) {
      errors.groupName = 'Group Name already exists';
    }
    if (!groupName.trim()) {
      errors.groupName = 'This field is required';
    }
    if (!priceBand || priceBand.length === 0) {
      errors.priceBand = 'This field is required';
    }
    if (!primaryAccount) {
      errors.primaryAccount = 'This field is required';
    }

    setErrorMsg(errors);

    if (Object.keys(errors).length === 0) {
      // Prepare data to send for update
      const payload = {
        groupId: id, 
        groupName,
        priceBand: priceBand.map(pb => pb.value),
        primaryAccount: primaryAccount._id,  // sending _id of primary account
        accounts: selectedAccount.map(acc => acc.value),  // mapping to only send the ids
        groupStatus: status,
      };

      try {
        const response = await http.put(`${BaseUrl}admin/editchefs`, payload);
        setIsLoading(false);
        setAlertMessage('Development Chef Updated Successfully');
        setAlertPopup(true);
      } catch (error) {
        setIsLoading(false);
        const msg = error?.response?.data?.message || "Error Adding Development Chef";
        setAlertMessage(msg);
        setAlertPopup(true);
        console.error("Error:", error);
      }
    }
  };

  const getUsedAccountIds = () => {
  const selectedBands = priceBand.map(pb => pb.value);

  return allChefs
    .filter(chef =>
      chef._id !== id && // exclude current group
      chef.priceBand?.some(band => selectedBands.includes(band))
    )
    .flatMap(chef => [
      ...(chef.accounts || []).map(acc => acc._id || acc),
      chef.primaryAccount?._id || chef.primaryAccount
    ])
    .filter(Boolean);
};

  return (
    <section className="dashboard-block">
      {alertPopup && (
      <div className='custom-alert-pop common_alert_popup' style={{ display: "block" }}>
        <div className='custom-alert-container'>
          <div className='custom-alert-wrap'>
            <div className='custom-alert-header'>
              <h4>Alert</h4>
            </div>
            <div className='custom-alert-body'>
              <p>{alertMessage}</p>

              <div className='alert-buttons'>
                <a onClick={() => window.location.href = '/development-chef'} className="popup-alert-btn button">OK</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          {!loading && (
          <div className="container">
            <h1 className="checkout-title">{canEdit ? 'Edit Development Chef' : 'View Development Chef'}</h1>
            <div className="right-table-outer-wrap">
              <form method="post" className="addform form-container-xs" onSubmit={handleSubmit}>
                <div className="input-field col-1">
                  <label>Group Name</label>
                  <input 
                    type="text" 
                    value={groupName} 
                    onChange={(e) => {
                      if (!isReadOnly) {
                        setGroupName(e.target.value);
                        setErrorMsg(prev => ({ ...prev, groupName: '' }));
                      }
                    }}                    
                    className="form-control" 
                    placeholder="Enter Group Name"
                    readOnly={isReadOnly}
                  />
                  {formSubmitted && errorMsg.groupName && <div className="error-msg">{errorMsg.groupName}</div>}
                </div>

                <div className="input-field col-1">
                  <label>Price Band</label>
                  <Select
                    isMulti
                    closeMenuOnSelect={false}
                    isDisabled={isReadOnly}
                    options={priceBands.map(band => ({ value: band, label: band }))}
                    value={priceBand}
                    onChange={(selected) => {
                        if (isReadOnly) return;
                        setPriceBand(selected);
                        setPrimaryAccount(null);
                        setSelectedAccount([]);
                        setInaccessibleAccounts([]); 
                        const selectedBands = selected.map(opt => opt.value);
                        const filtered = accounts.filter(acc => selectedBands.includes(acc.accountPriceListId));
                        setFilteredAccounts(filtered);
                        setErrorMsg(prev => ({ ...prev, priceBand: '' }));
                      
                    }}
                    className="form-control"
                    placeholder="Select Price Bands"
                    styles={{
                      menu: (base) => ({
                        ...base,
                        position: 'relative',
                        zIndex: 1
                      })
                    }}
                  />
                  {formSubmitted && errorMsg.priceBand && (
                    <div className="error-msg">{errorMsg.priceBand}</div>
                  )}
                </div>

                {priceBand && (
                  <div className="input-field col-1">
                    <label>Select Primary Account</label>
                    {missingPrimaryAccount && (
                      <p className="note-text">The primary account <strong>{missingPrimaryAccount}</strong> is currently inactive or website access is restricted.Please select a new primary account. When you click Update,the previous primary account will be removed from the chef group.</p>
                    )}
                    <select 
                      value={primaryAccount?._id || ""}
                      onChange={(e) => {
                        if (isReadOnly) return;
                        const selected = filteredAccounts.find(a => a._id === e.target.value);
                        // Remove previous primary from selectedAccount
                        setSelectedAccount(prevSelected =>
                        prevSelected.filter(acc => acc.value !== primaryAccount?._id)
                        );
                        setPrimaryAccount(selected);
                        setErrorMsg(prev => ({ ...prev, primaryAccount: '' }));
                      }}
                      className="form-control"
                      disabled={isReadOnly}
                    >
                      <option value="">-- Select Primary Account --</option>
                      {filteredAccounts
                        .filter(acc => (!getUsedAccountIds().includes(acc._id) || acc._id === primaryAccount?._id) && acc.accountWebSiteAccess === "Yes" && !hoAccountlist.includes(acc.accountCode) && !chefAccountList.includes(acc.accountCode) )
                        .map(account => (
                          <option key={account._id} value={account._id}>
                            {account.accountCode} - {account.accountName}
                          </option>
                      ))}
                    </select>
                    {formSubmitted && errorMsg.primaryAccount && <div className="error-msg">{errorMsg.primaryAccount}</div>}
                  </div>
                )}

                {primaryAccount && (
                  <div className="input-field col-1">
                    <label>Select Sub-Account Name (s)</label>
                    {inaccessibleAccounts.length > 0 && (
                      <p className="note-text">
                        The following account(s) are part of this group but currently inaccessible: {inaccessibleAccounts.join(', ')}. When you click Update, these accounts will be removed from the chef group.
                      </p>
                    )}
                    <Select
                      isMulti
                      closeMenuOnSelect={false}
                      isDisabled={isReadOnly}
                      options={filteredAccounts
                        .filter(acc => acc._id !== primaryAccount._id && (!getUsedAccountIds().includes(acc._id) || selectedAccount.some(sa => sa.value === acc._id)) && acc.accountWebSiteAccess === "Yes" && !chefAccountList.includes(acc.accountCode) )
                        .map(acc => ({
                          value: acc._id,
                          label: `${acc.accountCode} - ${acc.accountName}`,
                          data: acc
                        }))
                      }
                      value={selectedAccount.filter(acc => acc.value !== primaryAccount._id)} // Remove primary from selected
                      onChange={(selected) => {
                      if (isReadOnly) return;
                      // Remove primary if accidentally included manually or through logic mismatch
                      const cleanedSelection = selected.filter(acc => acc.value !== primaryAccount._id);
                      setSelectedAccount(cleanedSelection);
                      setErrorMsg(prev => ({ ...prev, selectedAccount: '' }));
                    }}
                      className="form-control"
                      styles={{
                        menu: (base) => ({
                          ...base,
                          position: 'relative', 
                          zIndex: 1
                        })
                      }}
                    />
                    {formSubmitted && errorMsg.selectedAccount && <div className="error-msg">{errorMsg.selectedAccount}</div>}
                  </div>
                )}

                {/* Status Checkbox */}
                <div className="input-field col-1">
                <label className='full-width'>Status</label>
                <select className='col-4' value={status} onChange={(e) => { 
                  if (isReadOnly) return; // prevent change
                  setStatus(e.target.value);
                  }}
                  disabled={isReadOnly}
                  >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>

                {canEdit && <button type="submit">Update</button>}&nbsp;&nbsp;
                <button onClick={cancelbtn}>Cancel</button>
              </form>
            </div>
          </div>
          )}
          {loading && <Loader />}
        </section>
        <Footer />
      </div>
    </section>
  );
};

export default EditChefs;
